import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import {
  login as loginAction,
  logout as logoutAction,
  register as registerAction,
  clearError,
  updateUserProfile as updateUserProfileAction
} from '../store/slices/authSlice';

export const useAuth = () => {
  const dispatch = useDispatch();
  const { user, isAuthenticated, loading, error } = useSelector(
    (state) => state.auth
  );

  const login = useCallback(
    (email, password) => {
      return dispatch(loginAction({ email, password }));
    },
    [dispatch]
  );

  const logout = useCallback(() => {
    return dispatch(logoutAction());
  }, [dispatch]);

  const register = useCallback(
    (email, password, firstName, lastName, inviteCode) => {
      return dispatch(registerAction({ email, password, firstName, lastName, inviteCode }));
    },
    [dispatch]
  );

  const clearAuthError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  const updateUserProfile = useCallback(
    (profileData) => {
      dispatch(updateUserProfileAction(profileData));
    },
    [dispatch]
  );

  return {
    user,
    isAuthenticated,
    loading,
    error,
    login,
    logout,
    register,
    clearAuthError,
    updateUserProfile
  };
};

export default useAuth;
